import { PureComponent, Fragment } from 'react'
import * as styles from 'components/features/pfm/RedemptionForm/ConfirmationStep.css'
import { ReduxFormProps } from 'interfaces/component'
import SubmitButton from 'components/features/pfm/RedemptionForm/SubmitButton'
import CancelButton from 'components/features/pfm/RedemptionForm/CancelButton'
import Button from 'components/features/pfm/Button/Button'
import { RedemptionStepNumber, RedemptionFormValues } from 'interfaces/bounty'
import redemptionReduxForm from 'components/features/pfm/RedemptionForm/redemptionReduxForm'
import confirmationStepSchema from 'schemas/redemptionSchema'
import { FormErrors } from 'redux-form'
import { redemptionFormFieldNames } from 'components/features/pfm/RedemptionForm/RedemptionForm'
import { prepareFieldErrors } from 'helpers/formHelpers'
import { NO_DIGITS_REGEX } from 'constants/bounty'

type ConfirmationField = { label: string, value: string }
type ConfirmationSection = ConfirmationField[]

type ConfirmationStepProps = ReduxFormProps<RedemptionFormValues> & {
  submitErrors: FormErrors<RedemptionFormValues>
  formValues: RedemptionFormValues
  onStepChange: (stepNumber: RedemptionStepNumber) => void,
}

class ConfirmationStep extends PureComponent<ConfirmationStepProps> {
  render () {
    const { formValues, handleSubmit, submitting } = this.props
    const { amount, bank_account_type, account_number, routing_number } = formValues
    return (
      <form onSubmit={ handleSubmit } className={ styles.confirmationStep }>
        { this.renderConfirmationTable([
          [
            { label: redemptionFormFieldNames.amount, value: `$${ amount }` },
          ],
          [
            { label: redemptionFormFieldNames.bank_account_type, value: bank_account_type },
            { label: redemptionFormFieldNames.account_number, value: account_number.replace(NO_DIGITS_REGEX, '') },
            { label: redemptionFormFieldNames.routing_number, value: routing_number.replace(NO_DIGITS_REGEX, '') },
          ],
        ]) }
        { this.renderError() }
        <div className={ styles.buttonWrapper }>
          <SubmitButton submitting={ submitting }>
            Submit Redemption
          </SubmitButton>
        </div>
        <CancelButton />
      </form>
    )
  }

  renderError () {
    const rawNonFieldErrors = this.props.error
    const rawSubmitErrors = this.props.submitErrors || {}

    if (this.props.submitting) {
      return null
    }

    const errors = []

    const nonFieldErrors = prepareFieldErrors(rawNonFieldErrors, true)
    errors.push(...nonFieldErrors.map(({ text }) => text))

    const fieldNames = Object.keys(rawSubmitErrors) as (keyof RedemptionFormValues)[]
    const errorFieldNames = fieldNames.reduce((prevErrorFieldNames, fieldName) => {
      if (rawSubmitErrors[fieldName]) {
        return [...prevErrorFieldNames, fieldName]
      } else {
        return prevErrorFieldNames
      }
    }, [])


    if (errorFieldNames.length) {
      errors.push('The following fields need your attention:')
    }

    if (!errors.length) {
      return null
    }

    return (
      <div className={ styles.errorBorder }>
        { errors.join(' ') }
        { errorFieldNames.length > 0 && (
          <ul className={ styles.errorFieldNameList }>
            { errorFieldNames.map((errorFieldName) => {
              return (
                <li className={ styles.errorFieldNameItem } key={ errorFieldName }>
                  { redemptionFormFieldNames[errorFieldName] }
                </li>
              )
            }) }
          </ul>
        ) }
      </div>
    )
  }

  renderConfirmationTable (confirmationSections: ConfirmationSection[]) {
    return (
      <div className={ styles.confirmationTable }>
        { confirmationSections.map(this.renderConfirmationSection) }
      </div>
    )
  }

  renderConfirmationSection = (confirmationSection: ConfirmationSection, stepNumber: RedemptionStepNumber) => {
    return (
      <div className={ styles.confirmationSection } key={ stepNumber }>
        <div className={ styles.confirmationSectionButtonWrapper }>
          <Button
            style='textOnly'
            size='tiny'
            onClick={ () => this.props.onStepChange(stepNumber) }
          >
            Edit
          </Button>
        </div>
        { confirmationSection.map(this.renderConfirmationField) }
      </div>
    )
  }

  renderConfirmationField = ({ label, value }: ConfirmationField) => {
    return (
      <Fragment key={ `${ label }-${ value }` }>
        <div className={ styles.confirmationLabel }>{ label }</div>
        <div className={ styles.confirmationValue }>{ value }</div>
      </Fragment>
    )
  }
}

export default redemptionReduxForm(ConfirmationStep, confirmationStepSchema)

